const MicrophoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="2" width="6" height="12" rx="3"/>
    <path d="M5 10a7 7 0 0 0 14 0"/>
    <line x1="12" y1="19" x2="12" y2="22"/>
    <line x1="9" y1="22" x2="15" y2="22"/>
  </svg>
);

const BuildingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M9 22V12h6v10"/>
    <path d="M3 9h18"/>
    <path d="M3 15h4M17 15h4"/>
  </svg>
);

const TYPES = [
  {
    id: "artist",
    label: "Artist",
    description: "Musician, band, or performer",
    Icon: MicrophoneIcon,
  },
  {
    id: "venue",
    label: "Venue",
    description: "Club, bar, festival, or space",
    Icon: BuildingIcon,
  },
];

export default function NewUserTypeModal({ onSelect }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative z-10 w-full max-w-md">
        <section className="panel p-8">
          <div className="mb-6 text-center">
            <h2 className="text-2xl font-bold tracking-tight text-zinc-900 dark:text-zinc-50">
              One last thing
            </h2>
            <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">
              Are you joining as an artist or a venue?
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {TYPES.map(({ id, label, description, Icon }) => {
              const TypeIcon = Icon;
              return (
              <button
                key={id}
                type="button"
                onClick={() => onSelect(id)}
                className={[
                  "relative flex flex-col items-center gap-3 rounded-xl border-2 px-4 py-6 transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/60",
                  "border-zinc-200 bg-white/60 hover:border-amber-400 hover:bg-amber-400/5",
                  "dark:border-white/[0.08] dark:bg-white/[0.03] dark:hover:border-amber-400 dark:hover:bg-amber-400/[0.06]",
                ].join(" ")}
              >
                <span className="rounded-lg p-2.5 bg-zinc-100 text-zinc-400 transition-colors dark:bg-white/[0.06] dark:text-zinc-500">
                  <TypeIcon />
                </span>
                <span className="flex flex-col items-center gap-0.5">
                  <span className="text-sm font-semibold text-zinc-700 dark:text-zinc-200">
                    {label}
                  </span>
                  <span className="text-center text-xs text-zinc-400 dark:text-zinc-500">
                    {description}
                  </span>
                </span>
              </button>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
}
